import { CommonInput } from './CommonInput';

export const TextInput = ({
  id,
  label,
  placeholder,
  value,
  onChange,

  labelWidth,
}: {
  id: string;
  label: string;
  placeholder?: string;
  value?: string;
  onChange: (value: string) => void;

  labelWidth?: number;
}) => (
  <CommonInput $labelWidth={labelWidth}>
    <label>{label}</label>
    <input
      type="text"
      id={id}
      placeholder={placeholder}
      value={value || ''}
      onChange={(e: any) => onChange(e.currentTarget.value)}
    />
  </CommonInput>
);
